// Import utils
import { getDocumentElement, getDocumentElements } from "../../Utils/Utils";

/**
 * Handle the calculation of the total sum.
 * 
 * @param       {array}     fields
 * 
 * @returns     {void}
 */
const TotalOnFarmWaterUseHandler = (fields, finalSummary) => {
    let sum = 0;

    fields.forEach(field => {
        sum += Number(field.value);
    });

    finalSummary.value = sum.toFixed(3);
};

/**
 * Pull in all the necessary field data for the final summary.
 * 
 * @returns     {void}
 */
export const UpdateTotalOnFarmWaterUse = () => {
    setInterval(() => {
        // Retrieve the summary fields
        const SummaryFields = getDocumentElements('.farm-calc-section--use [id^="tot_"]');
        const FinalSummary = getDocumentElement('#onFarmTotal');

        if (SummaryFields && FinalSummary) {
            TotalOnFarmWaterUseHandler(SummaryFields, FinalSummary);
        }
    }, 200);
};